
  import { Options, Vue } from "vue-class-component";

  @Options({
    props: {
      visible: {type: Boolean, default: false},
      isAbsolute: {type: Boolean, default: true}
    },
  })
  export default class Spinner extends Vue { }
